const Loader = () => (
  <svg viewBox='0 0 24 24'>
    <path d='M7.833 6.167h.834v1.666h-.834v.834H6.167v-.834h-.834V6.167h.834v-.834h1.666v.834Zm5-2.5h.834v1.666h-.834v.834h-1.666v-.834h-.834V3.667h.834v-.834h1.666v.834Zm-7.5 10H3.667v-.834h-.834v-1.666h.834v-.834h1.666v.834h.834v1.666h-.834v.834Zm2.5 2.5h.834v1.666h-.834v.834H6.167v-.834h-.834v-1.666h.834v-.834h1.666v.834Zm13.334-5v1.666h-.834v.834h-1.666v-.834h-.834v-1.666h.834v-.834h1.666v.834h.834Zm-3.334 5h.834v1.666h-.834v.834h-1.666v-.834h-.834v-1.666h.834v-.834h1.666v.834Zm-5 2.5h.834v1.666h-.834v.834h-1.666v-.834h-.834v-1.666h.834v-.834h1.666v.834Z' />
  </svg>
)

export { Loader }
